<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3 pt-4">
      <h5 class="p-0">
        <router-link
          style="font-size: 0.8em"
          :to="`/billing/consumption/${modelType}`">
          <i class="fas fa-arrow-left" />
        </router-link>
        {{ $d(new Date(`${period}-02`), 'monthYear') }}
      </h5>
    </div>

    <div class="vflex-row-1">
      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="loadData">

        <template slot="content">
          <table class="table">
            <thead>
              <tr>
                <th-sort field="title" :value="sort" @input="setSort">{{ $t('Name') }}</th-sort>
                <th-sort field="author_user_id" :value="sort" @input="setSort">{{ $t('Author') }}</th-sort>
                <th-sort field="created_at" :value="sort" @input="setSort">{{ $t('Created at') }}</th-sort>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="(item, index) in consumptions"
                :key="index">
                <td class="text-truncate">{{ item.title }}</td>
                <td class="text-truncate">{{ item.author_user_id.name }}</td>
                <td class="text-truncate">{{ $d(new Date(item.created_at), 'short') }}</td>
              </tr>
            </tbody>
          </table>
        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>
    </div>
  </div>

</template>

<script>
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'

export default {
  name: 'Consumption',
  components: {
    ThSort,
    Paginaty
  },
  props: {
  },
  data () {
    return {
      creating: true,
      loading: true,
      filters: {},
      sort: '-created_at'
    }
  },
  computed: {
    modelType () {
      return this.$route.params.type
    },
    period () {
      return this.$route.params.period
    },
    consumptions () {
      return this.$store.getters.getConsumptions
    },
    paginate () {
      return this.$store.getters.getConsumptionsPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    setSort
    */
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    },
    /*
    loadData
    */
    loadData (page = 1) {
      this.loading = true

      const params = {
        type: this.modelType,
        period: this.period,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectConsumptions', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BillingConsumption/BillingConsumptionDetails.vue